import {
    COMMON_IMAGE_VIEWER, COMMON_IMAGE_VIEWER_RESET,
} from './constants';

//
export const CommonImageViewerReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random(),
        showImageViewer: false,
        refresh: false,
        loading: false,
        error: false,
        success: false
    }
    const data = action.payload;
    switch (action.type) {
        case COMMON_IMAGE_VIEWER:
            ret.imageList = data.imageList;
            ret.showImageViewer = true;
            break;
        case COMMON_IMAGE_VIEWER_RESET:
            ret.showImageViewer = false;
            break;
        default:
            return {...state};
    }
    return ret;
}
